import React from "react";
import { Stack, Tooltip, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InsightsIcon from "@mui/icons-material/Insights";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const AnnouncementRowActions = ({ announcement, onPreview, onViewStats, onResetRecipients, onEdit, onDelete }) => {
  return (
    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
      <Tooltip title="Preview Modal">
        <IconButton size="small" color="primary" onClick={() => onPreview(announcement)}>
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="View Stats">
        <IconButton size="small" color="info" onClick={() => onViewStats(announcement.id)}>
          <InsightsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Re-broadcast (Reset user dismissals)">
        <IconButton size="small" color="warning" onClick={() => onResetRecipients(announcement.id)}>
          <RestartAltIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit">
        <IconButton size="small" onClick={() => onEdit(announcement)}>
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton size="small" color="error" onClick={() => onDelete(announcement.id)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default AnnouncementRowActions;
